/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A payload that will remove multiple client contacts from a client organization.
 * @export
 * @interface BulkRemoveClientContact
 */
export interface BulkRemoveClientContact {
	/**
	 *
	 * @type {Array<string>}
	 * @memberof BulkRemoveClientContact
	 */
	actorRIDs?: Array<string>;
}

/**
 * Check if a given object implements the BulkRemoveClientContact interface.
 */
export function instanceOfBulkRemoveClientContact(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function BulkRemoveClientContactFromJSON(json: any): BulkRemoveClientContact {
	return BulkRemoveClientContactFromJSONTyped(json, false);
}

export function BulkRemoveClientContactFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): BulkRemoveClientContact {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		actorRIDs: !exists(json, 'actorRIDs') ? undefined : json['actorRIDs'],
	};
}

export function BulkRemoveClientContactToJSON(
	value?: BulkRemoveClientContact | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		actorRIDs: value.actorRIDs,
	};
}
